class LoansDetailFinishDeadlineController {
  constructor() {
  }
}

export default LoansDetailFinishDeadlineController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansDetail/loansDetailFinishDeadline/loansDetailFinishDeadline.controller.js